import { IEquipment } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/Equipment.dto';

import { EPriceTypes } from '@r1-frontend/shared/types/EPriceTypes';

import { getPriceOptions } from '~/src/entities/equipment';
import { convertShopPrices, IPrice } from '~/src/entities/price';
import { stringFormatterSeoScript } from '~/src/features/_layout/SeoScripts/stringFormatterSeoScript';
import { sortFunctionWithRequestIdOnTop } from '~/src/helpers/functions';

interface IGetMinCostProduct {
    description: string,
    url: string,
    imagePath?: string,
}

interface IGetMinCostProductWithPrice extends IGetMinCostProduct {
    price: number,
}

export interface IPriceOptionProps {
    price: IPrice['value'],
    pricePromo?: IPrice['valuePromo'],
    label: string,
    id?: number,
}

const getPrice = (product: IPriceOptionProps) => product['price'] || product['pricePromo'] || 0;

export const getMinCostProduct = (products: IEquipment[]) => {
    const sortedProducts = products
        .map(product => {
            const options: IPriceOptionProps[] = getPriceOptions(
                convertShopPrices(product),
                null,
                false,
                sortFunctionWithRequestIdOnTop,
            );

            if (product.testDrive) {
                product.testDrive.pricesAfter.forEach(({ id, type, duration, value }) => {
                    const isLeasing = type === EPriceTypes.Leasing;
                    const uniqueTestDriveVariant = options.findIndex(({ id: optionId = 0 }) => optionId === id);

                    if (uniqueTestDriveVariant < 0) {
                        options.push({
                            label: isLeasing ? `Рассрочка на ${duration} мес.` : 'Полная стоимость',
                            price: value,
                        });
                    }
                });
            }
            options.sort((a, b) => getPrice(a) - getPrice(b));
            const minCostOption = options[0];

            return ({
                description: stringFormatterSeoScript(
                    `${product.category?.title || ''}: ${product.titleShort || product.title}. ${minCostOption.label} ${product.body || ''}`,
                ) || '',
                price: options[0].price,
                imagePath: product.imageWebp || product.image,
                url: `internet/equipment/${product.alias ? product.alias : product.id}`.replace('//', '/'),
            });
        })
        .sort((productA: IGetMinCostProductWithPrice, ProductB: IGetMinCostProductWithPrice) =>
            productA.price - ProductB.price);

    const result = sortedProducts[0] || {};

    return {
        ...result,
        price: result.price.toString(),
    };
};
